// Informations juridiques Wanderlust : remplacez une valeur vide ("") par la vraie donnée.
// Tant qu'une valeur est vide, le placeholder entre crochets s'affiche sur les pages légales.
export const LEGAL = {
  operator: "",            // [raison sociale / nom de l'exploitant à compléter]
  legalForm: "",           // [forme juridique à compléter]
  capital: "",             // [capital social à compléter si applicable]
  address: "",             // [adresse à compléter]
  siren: "",               // [SIREN / SIRET à compléter]
  vat: "",                 // [TVA intracommunautaire à compléter si applicable]
  publicationDirector: "", // [directeur de la publication à compléter]
  mediator: "",            // [médiateur à compléter]
  mediatorUrl: "",         // [site du médiateur à compléter]
  hostUrl: "",             // [URL de l'hébergeur à compléter si souhaité]
  hostAddress: "",         // [adresse de l'hébergeur à compléter si nécessaire]
  priceTaxNote: "",        // [TTC / à préciser selon statut fiscal]
  email: "contact@wanderlust.fr",
  host: "Emergent",
  brand: "Amagui AI",
  price: "4,90 €",
  updatedAt: "octobre 2026",
};

export const PLACEHOLDERS = {
  operator: "raison sociale / nom de l'exploitant à compléter",
  legalForm: "forme juridique à compléter",
  capital: "capital social à compléter si applicable",
  address: "adresse à compléter",
  siren: "SIREN / SIRET à compléter",
  vat: "TVA intracommunautaire à compléter si applicable",
  publicationDirector: "directeur de la publication à compléter",
  mediator: "médiateur à compléter",
  mediatorUrl: "site du médiateur à compléter",
  hostUrl: "URL de l'hébergeur à compléter si souhaité",
  hostAddress: "adresse de l'hébergeur à compléter si nécessaire",
  priceTaxNote: "TTC / à préciser selon statut fiscal",
};
